<template>
  <!-- 公共首页 -->
  <div class="container" id="home" ref="home">
    <div id="wrap" class="index">
      <div class="nav" :class="scroll ? 'backWhite' : ''">
        <div class="navbars center">
          <div class="logos">
            <a href="/#/home">
              <img src="../assets/img/logo.png" alt="logo" />
            </a>
          </div>
          <div class="navbar-menu">
            <ul>
              <li>
                <a href="#home">首页</a>
              </li>
              <li>
                <a href="#college">功能</a>
              </li>
              <li>
                <a href="#case">应用</a>
              </li>
              <li>
                <a href="#blogroll">合作</a>
              </li>
              <li>
                <a href="#contactUs">我们</a>
              </li>
            </ul>
          </div>
          <div class="navbar-login">
            <ul>
              <li style="cursor: pointer" class="navbar-loginBtn" v-if="loginInfo == null">
                <div><span @click="logins(0)">登录</span>|<span @click="logins(1)">注册</span></div>

                <!-- <a href="javaScript:void(0)">登录</a>|<a href="javaScript:void(0)">注册</a> -->
              </li>
              <li @mouseenter="enter" @mouseleave="leave" style="margin-right: 0" v-else class="">
                <div class="user navbar-loginBtn">
                  <span class="userName">{{ info.userName || info.nickName }}</span>
                  <img src="../assets/img/arrowA.png" />
                  <img class="userAvater" v-if="loginInfo.avatar" :src="loginInfo.avatar" alt="" />
                  <img class="userAvater" v-else src="../assets/img/u8.png" alt="" />
                </div>
                <div v-show="showList" class="menuCover">
                  <div style="font-size: 16px">应用平台</div>
                  <div class="powerCover" style="border-bottom: 1px solid #e2e2e2; padding-bottom: 10px">
                    <div v-for="(item, index) in powerList" @click="toDetail(item)" class="powerList" :key="index">
                      {{ item.applicationName }}
                    </div>
                  </div>
                  <div style="font-size: 16px" @click="loginOut">退出登录</div>
                </div>

                <!-- <a href="javaScript:void(0)">登录</a>|<a href="javaScript:void(0)">注册</a> -->
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="banner">
        <div class="center">
          <div class="header-inner">
            <img src="../assets/img/u855.svg" />
            <div class="header-innerTxt">
              <h1>小牧丁</h1>
              <p>站在最大多数劳动人民的一面</p>
            </div>
          </div>
        </div>
      </div>
      <!--产品功能-->
      <div class="collegeCont" id="college">
        <div class="center">
          <h1>产品功能</h1>
          <div class="collegeContTxt">
            <p>
              陕西微牧云信息科技有限公司是整合链接分散小农主体、带动小微农户通过畜牧产业致富的引领企业，旗下的APP“小牧丁”是中国农牧行业领先的畜只在线展销平台，通过人工智能技术支持，可实现农民农产与供应链无缝直采、涉农金融保险精准触达等服务，从而带动农牧产业数字化发展，加快农业农村现代化建设、推进乡村振兴。
            </p>
          </div>
          <div class="collBox">
            <ul class="collUls">
              <li>
                <a>
                  <img src="../assets/img/u915.png" />
                  <div class="collLis_tit">
                    <h6>Ai实时管理</h6>
                  </div>
                  <div class="collLis_txt">
                    <p><span>安防监控</span><span>智能盘点</span></p>
                    <p><span>畜只状态监测</span><span>异常告警</span></p>
                  </div>
                </a>
              </li>
              <li>
                <a>
                  <img src="../assets/img/u916.png" />
                  <div class="collLis_tit">
                    <h6>直播展销</h6>
                  </div>
                  <div class="collLis_txt">
                    <p><span>可视化牧场</span><span>直播展示</span></p>
                    <p><span>在线销售</span><span>产地直采</span></p>
                  </div>
                </a>
              </li>
              <li>
                <a>
                  <img src="../assets/img/u914.png" />
                  <div class="collLis_tit">
                    <h6>农技指导</h6>
                  </div>
                  <div class="collLis_txt">
                    <p><span>远程指导</span><span>直播培训</span></p>
                    <p><span>视频课件</span><span>在线答疑</span></p>
                  </div>
                </a>
              </li>
              <li>
                <a>
                  <img src="../assets/img/u919.png" />
                  <div class="collLis_tit">
                    <h6>金融保险</h6>
                  </div>
                  <div class="collLis_txt">
                    <p><span>活体抵押贷款</span><span>畜只保险</span></p>
                    <p><span>财政补贴</span><span>风控管理</span></p>
                  </div>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="case" id="case">
        <div class="scrollleft">
          <h3>应用案例</h3>
          <div class="bgCase">
            <div class="bg1"></div>
            <!-- <div class="bg2" style="background-image:url('../assets/img/caseimg4.jpg');">
            </div> -->
          </div>
        </div>
      </div>
      <div class="blogroll" id="blogroll">
        <div class="center">
          <h3>生态合作伙伴</h3>
          <ul>
            <li>
              <a><img src="../assets/img/u961.svg" /></a>
            </li>
            <li>
              <a><img src="../assets/img/u956.svg" /></a>
            </li>
            <li>
              <a><img src="../assets/img/u957.svg" /></a>
            </li>
            <li>
              <a><img src="../assets/img/u953.svg" /></a>
            </li>
            <li>
              <a><img src="../assets/img/u958.svg" /></a>
            </li>
            <li>
              <a><img src="../assets/img/u959.svg" /></a>
            </li>
            <li>
              <a><img src="../assets/img/u955.svg" /></a>
            </li>
            <li>
              <a><img src="../assets/img/u952.svg" /></a>
            </li>
            <li>
              <a><img src="../assets/img/u951.svg" /></a>
            </li>
            <li>
              <a><img src="../assets/img/u954.svg" /></a>
            </li>
            <li>
              <a><img src="../assets/img/u962.svg" /></a>
            </li>
            <li>
              <a><img src="../assets/img/u960.svg" /></a>
            </li>
          </ul>
        </div>
      </div>
      <!--联系我们-->
      <div class="contactUs" id="contactUs">
        <div class="center">
          <div class="contact">
            <ul>
              <li>
                <a>
                  <div class="cotL">
                    <img src="../assets/img/u976.png" />
                    <p>电话</p>
                  </div>
                  <div class="cotR">
                    <p>17611518222</p>
                    <p>15929397888</p>
                  </div>
                </a>
              </li>
              <li>
                <a>
                  <div class="cotL">
                    <img src="../assets/img/u978.png" />
                    <p>邮箱</p>
                  </div>
                  <div class="cotR">
                    <p>578500073@qq.com</p>
                    <p>240853545@qq.com</p>
                  </div>
                </a>
              </li>
              <li>
                <a>
                  <div class="cotL">
                    <img src="../assets/img/u977.png" />
                    <p>地址</p>
                  </div>
                  <div class="cotR">
                    <p>陕西省榆林市高新区明珠大道榆商大厦B座26层</p>
                  </div>
                </a>
              </li>
            </ul>
          </div>
          <div class="power">
            陕西微牧云信息科技有限公司<a target="_blank" href="https://beian.miit.gov.cn/#/Integrated/index">陕ICP备2020017629号</a>
          </div>
        </div>
        <div class="foot">
          <div class="center">
            <img src="../assets/img/u970.svg" />
            <img src="../assets/img/u971.svg" />
            <div class="foot-list">
              <p style="color: #007d50"><i class="foot-list-and"></i> ios下载</p>
              <p style="color: #ff9a05; margin-left: 12px"><i class="foot-list-ios"></i> 安卓下载</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      width="740px"
      stylel="height:480px;border-radius:10px;"
      :visible.sync="showDialog"
      @click="closeDialog('paramD')"
      :close-on-click-modal="false"
    >
      <div class="loginBox" v-if="showDialog">
        <div class="loginBoxL">
          <div class="loginTop">
            <ul>
              <li :class="tabIndex == 0 ? 'cur' : ''" @click="tab(0)">短信验证登录</li>
              <li :class="tabIndex == 1 ? 'cur' : ''" @click="tab(1)">账号密码登录</li>
            </ul>
          </div>
          <div class="loginBot">
            <div class="loginBotTab" v-if="tabIndex == 0">
              <ul>
                <li>
                  <input v-model="subform.mobile" type="text" placeholder="请输入手机号码" class="p10" />
                </li>
                <li>
                  <input
                    autocomplete="off"
                    v-model="subform.code"
                    style="width: 120px"
                    type="text"
                    class="p10"
                    placeholder="请输入验证码"
                  />
                  <button
                    @click="getCode"
                    v-if="setCode == '获取验证码'"
                    style="width: 120px; text-align: center; line-height: 70px; font-size: 16px"
                  >
                    {{ setCode }}
                  </button>
                  <button v-else style="width: 120px; text-align: center; line-height: 70px; font-size: 16px">
                    {{ setCode }}
                  </button>
                </li>
                <li>
                  <p style="white-space: nowrap">新手机号验证后将自动注册</p>
                </li>
              </ul>
            </div>
            <div v-else class="loginBotTab loginBotTab2">
              <ul>
                <li>
                  <input v-model="ruleForm.username" type="text" placeholder="请输入手机号码" class="p10" />
                </li>
                <li>
                  <input autocomplete="off" v-model="ruleForm.password" type="password" placeholder="请输入密码" class="p10" />
                  <!-- <span class="open"></span> -->
                </li>
                <li>
                  <!-- <a>新手机号验证后将自动注册</a> -->
                </li>
              </ul>
            </div>
          </div>
          <div class="loginBtnBox">
            <a style="cursor: pointer" @click="loginBtn" @keyup.enter="keyDown(e)" class="loginBtn">登录</a>
            <div class="loginTxt">
              点击登录或完成账号注册表示您已阅读<br />并同意微牧云<a target="_blank" href="http://down.xiaomuding.com/userService.html"
                >《用户协议》</a
              >和<a target="_blank" href="http://down.xiaomuding.com/conceal.html">《隐私政策》</a>
            </div>
          </div>
        </div>
        <div class="loginBoxR">
          <!-- <h3>打开<a href="http://xiaomuding.com/">小牧丁APP</a><br>扫描二维码登录</h3>
		<img src="../assets/img/ewm.png" />			<p>如果您还未下载小牧丁APP<br>扫描二维码即可下载</p> -->
          <h3>扫码下载<a>小牧丁APP</a></h3>
          <img src="../assets/img/ewm.png" />
        </div>
      </div>
    </el-dialog>

    <!-- 见犊补母 多角色区域选择 旧的 -->
    <dialogEL title="选择区域角色" :visible="regionalJDBM" width="750px" :closeOnClickModal="false" @close="regionalJDBMClose()">
      <template #dialogContent>
        <div class="reginalRoleTemplate">
          <ul class="horizontal_layout">
            <li
              v-for="(item, index) in regionalRoleData_JDBM"
              :key="index"
              :class="{ artive: regionalRoleIndex_JDBM === index }"
              @click="regionalRoleTab_JDBM(item, index)"
            >
              <section v-if="item.personOrg">
                <p>
                  {{ item.personOrg.deptName || '暂无区域' }}
                  <span v-if="item.personOrg.manageAreaCode">({{ item.personOrg.manageAreaCode }})</span>
                </p>
              </section>
              <section v-if="item.personOrg">
                <p>
                  {{ item.personOrg.roleName }} <span>{{ item.personOrg.roleCode }}</span>
                </p>
                <p>{{ item.personOrg.address }}</p>
              </section>
            </li>
          </ul>
          <div class="newEquipmentAddedBtn">
            <el-button class="sure" @click="regionalRoleSubmit_JDBM()">确定</el-button>
          </div>
        </div>
      </template>
    </dialogEL>
    <!-- 见犊补母 多角色区域选择 新的 -->
    <dialogEL title="选择区域角色" :visible="regionalJDBM_NEWS" width="800px" :closeOnClickModal="false" @close="regionalJDBM_NEWS_Close()">
      <template #dialogContent>
        <div class="multiRoleData">
          <div class="multiRoleDataMun">
            <div class="multiRoleDataMain" v-for="(item, index) in regionalRoleData_JDBM.userAppInfo" :key="index">
              <aside class="title" v-if="titleEvent(item.deptUserRole)">
                {{ item.deptName }}
              </aside>
              <div class="multiRoleDataList">
                <section
                  v-for="(dept, deptIndex) in item.deptUserRole"
                  :key="deptIndex"
                  :class="{ active: dept.hidStatus }"
                  @click="multiRoleTab_JDBM(dept, deptIndex, item, index)"
                  v-show="!['JDBM_FARMER', 'JDBM_OPERATER'].includes(dept.roleCode)"
                >
                  <p>{{ dept.roleName }}</p>
                </section>
              </div>
            </div>
          </div>
          <div class="newEquipmentAddedBtn">
            <el-button class="sure" @click="regionalRoleSubmit_JDBM()">确定</el-button>
          </div>
        </div>
      </template>
    </dialogEL>

    <!-- 肉牛 - 如果多角色和区域选择项 -->
    <dialogEL title="选择区域角色" :visible="regionalRoleSts" width="750px" :closeOnClickModal="false" @close="regionalRoleStsClose()">
      <template #dialogContent>
        <div class="reginalRoleTemplate">
          <ul class="horizontal_layout">
            <li
              v-for="(item, index) in regionalRoleData"
              :key="index"
              :class="{ artive: regionalRoleIndex === index }"
              @click="regionalRoleTab(item, index)"
            >
              <section>
                <p>
                  {{ item.openName || '暂无区域' }}
                  <span v-if="item.deptUserRole.length == 1">({{ item.deptUserRole[0].roleName }})</span>
                  <span v-else>(多角色)</span>
                </p>
              </section>
              <section>
                <p v-if="item.deptUserRole.length == 1">
                  {{ item.deptUserRole[0].roleName }} <span>{{ item.deptUserRole[0].roleCode }}</span>
                </p>
                <p v-else-if="regionalDeptRoleCurrentData.length > 0">
                  {{ regionalDeptRoleCurrentData[0].roleName }} <span>{{ regionalDeptRoleCurrentData[0].roleCode }}</span>
                </p>
                <p v-else>选择区域 <span>选择角色</span></p>
                <p v-if="item.deptUserRole.length == 1">{{ item.deptUserRole[0].fullAreaName }}</p>
                <p v-else-if="regionalDeptRoleCurrentData.length > 0">
                  {{ regionalDeptRoleCurrentData[0].fullAreaName }}
                </p>
                <p v-else>暂无地址</p>
              </section>
            </li>
          </ul>
          <div class="newEquipmentAddedBtn">
            <el-button class="sure" @click="regionalRoleSubmit()">确定</el-button>
          </div>
        </div>
      </template>
    </dialogEL>
    <!-- 肉牛 - 多角色和多区域选择项 -->
    <dialogEL
      title="选择区域角色"
      :visible="regionalDeptUserRoles"
      width="750px"
      :closeOnClickModal="false"
      @close="regionalDeptRoleStsClose()"
    >
      <template #dialogContent>
        <div class="reginalRoleTemplate">
          <ul class="horizontal_layout">
            <li
              v-for="(item, index) in regionalDeptRoleData"
              :key="index"
              :class="{ artive: regionalDeptRoleIndex === index }"
              @click="regionalDeptRoleTab(item, index)"
            >
              <section>
                <p>
                  {{ item.areaName || '暂无区域' }} <span v-if="item.areaCode">({{ item.areaCode }})</span>
                </p>
              </section>
              <section>
                <p>
                  {{ item.roleName }} <span>{{ item.roleCode }}</span>
                </p>
                <p>{{ item.fullAreaName }}</p>
              </section>
            </li>
          </ul>
          <!-- <div class="newEquipmentAddedBtn">
            <el-button class="sure" @click="regionalRoleSubmit()">确定</el-button>
          </div> -->
        </div>
      </template>
    </dialogEL>

    <!-- 种畜禽多角色 -->
    <dialogEL title="选择区域角色" :visible="regionalStatus_ZXQ" width="800px" :closeOnClickModal="false" @close="regionalZXQClose">
      <template #dialogContent>
        <div class="multiRoleData">
          <div class="multiRoleDataMun">
            <div class="multiRoleDataMain" v-for="(item, index) in regionalData_ZXQ.userAppInfo" :key="index">
              <aside class="title">
                {{ item.deptName || '超级管理员' }}
                <!-- <span>({{ item.deptId }})</span> -->
              </aside>
              <div class="multiRoleDataList">
                <section
                  v-for="(dept, deptIndex) in item.deptUserRole"
                  :key="deptIndex"
                  :class="{ active: dept.hidStatus }"
                  @click="multiRoleTab(dept, deptIndex, item, index)"
                  v-show="!['FARMER_SIGN'].includes(dept.roleCode) && !dept.moduleStatus"
                >
                  <p>
                    {{ dept.roleName }}
                    <!-- <span>({{ dept.roleCode }})</span> -->
                  </p>
                </section>
              </div>
            </div>
          </div>
          <div class="newEquipmentAddedBtn">
            <el-button class="sure" @click="regionalSubmit_ZXQ()">确定</el-button>
          </div>
        </div>
      </template>
    </dialogEL>
  </div>
</template>

<script>
import Vue, { set } from 'vue';
import { sendCodeApi, registerApi, accountSmsLoginApi, organization } from '@/api/index';
import { login, getUserAppInfo, getSecret, loginCode, getUserBaseInfo } from '@/api/login';
import { getZiZhouUserInfo, getUserInfoV2, getZhxmUserInfo, getUserInfoCall } from '@/api/cattlesubsidy';
import { getUserFarmInfo, getWebMenuTreeByAppId } from '@/api/system';
import { encryption } from '@/utils/util';
import { passwordKey } from '@/utils/config';
import { getFinanceUserInfo } from '@/api/loanAdmin';
import { getBreedUserInfo_Beef } from '@/api/beefCattleApi';
import { getSeedUserInfo_LB } from '@/api/breedingLivestockApi';
import common from '@/views/poultryStorage/commone/common.js';
import dialogEL from '@/components/module/dialogEL/index.vue';
import { time } from 'echarts';
import { mapState, mapMutations } from 'vuex';
// loginBtn
export default {
  components: {
    dialogEL
  },
  data() {
    return {
      info: null,
      loginInfo: null,
      showDialog: false,
      tabIndex: 0,
      code: 0,
      setCode: '获取验证码',
      num: 60,
      powerList: [],
      subform: {
        mobile: '',
        scope: 'server',
        code: ''
      },
      sendCode: {
        codeType: 'login_system_sms_code',
        userAccount: ''
      },
      ruleForm: {
        username: '',
        scope: 'server',
        password: ''
      },
      clock: null,
      showList: false,
      scroll: false,
      loginToken: '',
      farmId: '', // 智慧养殖牧场ID

      // 选择区域和角色 - 肉牛良繁
      regionalRoleSts: false,
      regionalRoleData: [],
      regionalRoleCurrentData: {},
      regionalRoleIndex: -1,
      regionalApplicationType: null,
      // 选择区域和多角色处理
      regionalDeptUserRoles: false,
      regionalDeptRoleData: [],
      regionalDeptRoleIndex: -1,
      regionalDeptRoleCurrentData: [],
      showScreenInfo: '', // 大屏值
      // 选择区域和角色 - 见犊补母 旧的
      regionalJDBM: false,
      regionalRoleData_JDBM: [],
      regionalRoleIndex_JDBM: -1,
      item_JDBM: {},
      // 选择区域和角色 - 见犊补母 新的
      regionalJDBM_NEWS: false,
      // 多区域-种畜禽
      regionalStatus_ZXQ: false,
      regionalData_ZXQ: {},
      regionalCurrentData_ZXQ: {}, // 当前数据
      regionalCurrentData: {},
      regionalType: ''
    };
  },
  // 创建完毕状态(里面是操作)
  created() {
    if (this.$route.query.name && this.$route.query.name == 'loginout') {
      this.loginInfo = null;
    }
    this.loginInfo = JSON.parse(localStorage.getItem('userInfo'));
    this.info = JSON.parse(localStorage.getItem('info'));
    if (this.loginInfo) {
      this.getuserO();
    }
    this.listenerFunction();
    getSecret().then(res => {
      this.loginToken = res.data.data; // 获取登录接口的token
    });
  },
  mounted() {
    var aList = document.querySelectorAll('.navbar-menu a');
    // console.log(aList, 'alist')
    // window.addEventListener("keydown", this.keyDown);
    //给每一个a标签注册点击事件
    let that = this;
    for (var i = 0; i < aList.length; i++) {
      aList[i].addEventListener('click', function (e) {
        //阻止a标签的默认行为
        e = e || window.event;
        e.preventDefault();

        //获取整个href路径
        //var target = this.href;
        //获取#片段识别符
        var target = this.hash;
        //获取box参照于body定位的top值
        var offsetTop = document.querySelector(target).offsetTop - 163;
        that.$nextTick(() => {
          that.$refs.home.scrollTo(0, document.querySelector(target).offsetTop - 163);
        });
        // document.querySelector(target).scrollIntoView()
        //将页面跳转到对应的位置
        // document.documentElement.scrollTop = offsetTop;
      });
    }
  },
  // 里面的函数只有调用才会执行
  methods: {
    ...mapMutations(['mutCurrentLivestock', 'mutLivestockListStroe']),
    titleEvent(data) {
      if (data && data.length > 0) {
        const _JDBM = data.filter(item => !['JDBM_FARMER', 'JDBM_OPERATER'].includes(item.roleCode));
        if (_JDBM && _JDBM.length > 0) return true;
        else return false;
      } else return false;
    },
    regionalRoleStsClose() {
      this.regionalRoleSts = false;
    },
    regionalDeptRoleStsClose() {
      this.regionalDeptUserRoles = false;
    },
    regionalJDBMClose() {
      this.regionalJDBM = false;
    },
    regionalZXQClose() {
      this.regionalStatus_ZXQ = false;
    },
    // 见犊
    regionalJDBM_NEWS_Close() {
      this.regionalJDBM_NEWS = false;
    },
    regionalRoleTab(item, index) {
      // this.showScreenInfo = item.showScreenInfo[0];
      if (item.deptUserRole.length > 1) {
        this.regionalRoleIndex = index;
        this.regionalDeptUserRoles = true;
        this.regionalDeptRoleData = item.deptUserRole;
      } else {
        if (this.regionalRoleIndex === index) return false;
        this.regionalRoleIndex = index;
        this.regionalRoleCurrentData.userAppInfo = [item.deptUserRole[0]];
        localStorage.setItem('UserInformation_Beef', JSON.stringify(this.regionalRoleCurrentData));
      }
      // localStorage.setItem('showScreenInfo', JSON.stringify(this.showScreenInfo));
    },
    // 选择多角色
    regionalDeptRoleTab(item, index) {
      if (this.regionalDeptRoleIndex === index) return false;
      this.regionalDeptRoleIndex = index;
      this.regionalDeptRoleCurrentData = [item];
      this.regionalRoleCurrentData.userAppInfo = [item];
      localStorage.setItem('UserInformation_Beef', JSON.stringify(this.regionalRoleCurrentData));
      this.regionalDeptUserRoles = false;
    },
    //
    regionalRoleTab_JDBM(item_J, index) {
      if (this.regionalRoleIndex_JDBM === index) return false;
      this.regionalRoleIndex_JDBM = index;

      let roleCode = item_J.roleCode;
      if (roleCode.search('JDBM_MANAGER') > -1) {
        this.item_JDBM.roleCode = 'JDBM_MANAGER';
        this.item_JDBM.realRoleCode = 'JDBM_MANAGER';
      }
      this.item_JDBM.showUserInfo = item_J.showUserInfo[0]; // 获取大屏控制值
      localStorage.setItem('itemInfo', JSON.stringify(this.item_JDBM));
      localStorage.setItem('applicationType', this.item_JDBM.applicationType);
      localStorage.setItem('deptList', JSON.stringify(item_J));
    },
    regionalRoleSubmit() {
      this.getWebMenuTreeByAppId(this.regionalRoleCurrentData.userAppInfo[0]);
    },
    regionalRoleSubmit_JDBM() {
      // window.open(`${window.location.origin}/#/homeB/index`, '_blank');
      const deptUserRole_JDBM = JSON.parse(localStorage.getItem('deptUserRole_JDBM'));
      this.getWebMenuTreeByAppId({
        roleCode: deptUserRole_JDBM ? deptUserRole_JDBM.roleCode : ''
      });
    },
    getUserBaseInfo() {
      var _this = this;
      getUserBaseInfo({}).then(res => {
        if (res.data.code === 0) {
          if (res.data.data.userAccount == '18591949210') {
            console.log(this.info);
            res.data.data.authInfo = '6';
            res.data.data.authProvincesCityAreas = '42384';
            res.data.data.authProvincesCityAreasName = '陕西省榆林市子洲县';
            res.data.data.deptId = '42384';
            res.data.data.optAuthType = '2';
            res.data.data.optAuthTypes = ['4', '2'];
            res.data.data.provincialAndMunicipalLevel = '3';
          }
          this.info = res.data.data;
          localStorage.setItem('info', JSON.stringify(res.data.data));
        } else {
          _this.$message({
            type: 'info',
            message: res.data.msg
          });
        }
      });
    },
    loginOut() {
      this.$confirm('退出登录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          localStorage.removeItem('token');
          localStorage.removeItem('farmIdear');
          localStorage.removeItem('userPhone');
          localStorage.removeItem('userInfo');
          localStorage.removeItem('item');
          localStorage.removeItem('permissiontable');
          localStorage.removeItem('zizhouuserInfo');
          this.loginInfo = null;
          setTimeout(() => {
            this.$message({
              type: 'success',
              message: '已退出登录!'
            });
          }, 1000);
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
    },
    toDetail(item) {
      // 智慧养殖
      if (item.applicationType == 1) {
        getUserFarmInfo({
          // 获取养殖场列表
          applicationType: this.applicationType
        }).then(res => {
          let infoLocal = null;
          res.data.data.forEach(item => {
            if (item.applicationId == 5) {
              infoLocal = item;
            }
          });
          localStorage.setItem('farmIdear', infoLocal.farmItems[0].farmId);
          localStorage.setItem('livestockTyper', infoLocal.farmItems[0].livestockType);
          localStorage.setItem('roleCode', infoLocal.farmItems[0].roleCode);
          localStorage.setItem('roleId', infoLocal.farmItems[0].roleId);
          localStorage.setItem('applicationType', 1);
          localStorage.setItem('UserInformation_ZHYZ', JSON.stringify(infoLocal));
          window.open(`${window.location.origin}/#/homeZ/datas?login=1`, '_blank'); // login=1 是否来自登录
        });
        localStorage.setItem('itemInfo', JSON.stringify(item));
      }
      // 智慧畜牧
      if (item.applicationType == 2) {
        // this.$router.push({
        //   path: '/SmartLivestock/homeview'
        // })
        localStorage.setItem('applicationType', 2);
        getUserBaseInfo({}).then(res => {
          const { code, data, msg } = res.data;
          if (Number(code) === 0) {
            this.info = data;
            localStorage.setItem('info', JSON.stringify(data));
            getZhxmUserInfo({}).then(res => {
              const { code, data, msg } = res.data;
              if (Number(code) === 0) {
                localStorage.setItem('userInfo_ZHXM', JSON.stringify(data[0]));
                window.open(`${window.location.origin}/#/SmartLivestock/homeview`, '_blank');
              }
            });
          } else {
            this.$message({
              type: 'info',
              message: msg
            });
          }
        });
        // window.open(`${window.location.origin}/#/SmartLivestock/homeview`, '_blank');
        localStorage.setItem('itemInfo', JSON.stringify(item));
      }
      // 智慧屠宰
      if (item.applicationType == 5) {
        // this.$router.push({
        //   path: '/homeT/passageManage'
        // })
        localStorage.setItem('applicationType', 5);
        window.open(`${window.location.origin}/#/homeT/passageManage`, '_blank');
        localStorage.setItem('itemInfo', JSON.stringify(item));
      }
      // 疫病预警监测
      if (item.applicationType == 11) {
        localStorage.setItem('applicationType', 11);
        window.open(`${window.location.origin}/#/homeF/index`, '_blank');
        localStorage.setItem('itemInfo', JSON.stringify(item));
      }
      // 助贷管理

      if (item.applicationType === 12) {
        localStorage.setItem('applicationType', 12);
        localStorage.setItem('itemInfo', JSON.stringify(item));
        getFinanceUserInfo({}).then(res => {
          let loans = res.data.data;
          localStorage.setItem('loans', JSON.stringify(loans.userAppInfo[0]));
          if (loans.userAppInfo[0].clientId === '20000') {
            window.open(`${window.location.origin}/#/loanaidinstitutions/index`, '_blank');
          }
          if (loans.userAppInfo[0].clientId === '30000') {
            window.open(`${window.location.origin}/#/loanAdmin/index`, '_blank');
          }
        });
      }
      // 见犊补母
      if (item.applicationType == 7) {
        localStorage.setItem('applicationId', item.applicationId);
        // getUserInfoCall   getUserInfoV2
        getUserInfoCall({
          // deptId: item.deptId,
          applicationId: item.applicationId
        }).then(res => {
          const { code, data, msg } = res.data;
          if (Number(code) === 0) {
            // 判定是否是多区域或者多角色
            if (data) {
              this.item_JDBM = item;
              if (
                data.userAppInfo &&
                ((data.userAppInfo[0].deptUserRole && data.userAppInfo[0].deptUserRole.length > 1) || data.userAppInfo.length > 1)
              ) {
                this.regionalRoleData_JDBM = this.initInitializeData(data) || [];
                this.regionalJDBM_NEWS = true;
                localStorage.setItem('multiRoleAll_JDBM', JSON.stringify(data));
              } else {
                console.log('单个角色');
                localStorage.setItem('multiRoleAll_JDBM', JSON.stringify(data));

                this.item_JDBM.showUserInfo = data.userAppInfo[0].showScreenInfo[0];
                localStorage.setItem('itemInfo', JSON.stringify(this.item_JDBM));
                localStorage.setItem('applicationType', this.item_JDBM.applicationType);
                localStorage.setItem('userApplication_JDBM', JSON.stringify(data.userAppInfo[0]));
                localStorage.setItem('deptUserRole_JDBM', JSON.stringify(data.userAppInfo[0].deptUserRole[0]));

                this.getWebMenuTreeByAppId({
                  roleCode: data.userAppInfo[0].deptUserRole[0].roleCode
                });
              }
            }
          } else common.isMessage(msg);

          // if (data.deptList.length > 1) {
          //   this.item_JDBM = item;
          //   this.regionalRoleData_JDBM = data.deptList || [];
          //   this.regionalJDBM = true;
          // } else {
          //   let roleCode = data.deptList[0].roleCode;
          //   if (roleCode.search('JDBM_MANAGER') > -1) {
          //     item.roleCode = 'JDBM_MANAGER';
          //     item.realRoleCode = 'JDBM_MANAGER';
          //   }
          //   item.showUserInfo = data.deptList[0].showUserInfo[0]; // 获取大屏控制值
          //   localStorage.setItem('itemInfo', JSON.stringify(item));
          //   localStorage.setItem('applicationType', item.applicationType);
          //   localStorage.setItem('deptList', JSON.stringify(data.deptList[0]));
          //   window.open(`${window.location.origin}/#/homeB/index`, '_blank');
          // }
        });
      }
      // 智慧养蜂
      if (item.applicationType == 8) {
        // this.$router.push({
        //   path: '/homeT/passageManage'
        // })
        localStorage.setItem('applicationType', 8);
        window.open(`${window.location.origin}/#/wasp/index`, '_blank');
        localStorage.setItem('itemInfo', JSON.stringify(item));
      }
      // 中国移动客户平台
      if (item.applicationType == 100) {
        // this.$router.push({
        //   path: '/homeT/passageManage'
        // })
        localStorage.setItem('applicationType', 100);
        window.open(`${window.location.origin}/#/homeB/index`, '_blank');
        localStorage.setItem('itemInfo', JSON.stringify(item));
      }
      // 畜产品管理
      if (item.applicationType == 0) {
        // this.$router.push({
        //   path: '/homeT/passageManage'
        // })
        localStorage.setItem('applicationType', 0);
        window.open(`${window.location.origin}/#/products/visual`, '_blank');
        localStorage.setItem('itemInfo', JSON.stringify(item));
      }
      // 畜牧平台
      if (item.applicationType == 10) {
        localStorage.setItem('applicationType', item.applicationType);
        localStorage.setItem('applicationId', item.applicationId);
        getZiZhouUserInfo({}).then(res => {
          localStorage.setItem('zizhouuserInfo', JSON.stringify(res.data.data[0]));
          window.open(`${window.location.origin}/#/zzry/homeview`, '_blank');
        });
        localStorage.setItem('itemInfo', JSON.stringify(item));
      }
      // 肉牛良繁平台
      if (item.applicationType == 14) {
        localStorage.setItem('applicationType', item.applicationType);
        localStorage.setItem('applicationId', item.applicationId);
        localStorage.setItem('itemInfo', JSON.stringify(item));
        getBreedUserInfo_Beef()
          .then(res => {
            const { code, data, msg } = res.data;
            // data.userAppInfo.forEach((item, index) => {
            //   item.deptUserRole.forEach((val, key) => {
            //     if (val.roleCode === 'AREA_FARMER') {
            //       item.deptUserRole.splice(key, 1);
            //     }
            //   });
            // });
            if (Number(code) === 0) {
              // 多个区域 | 一个区域 多个角色
              if (
                (data.userAppInfo && data.userAppInfo.length > 1) ||
                (data.userAppInfo && data.userAppInfo[0].deptUserRole && data.userAppInfo[0].deptUserRole.length > 1)
              ) {
                this.regionalData_ZXQ = this.initInitializeData(data);
                this.regionalStatus_ZXQ = true;
                localStorage.setItem('multiRoleLocalData', JSON.stringify(this.regionalData_ZXQ));
              } else {
                // 一个区域 单个角色
                localStorage.setItem('multiRoleLocalData', JSON.stringify(data));
                let _data = JSON.parse(localStorage.getItem('multiRoleLocalData'));
                _data.userAppInfo = [];
                if (data.userAppInfo && data.userAppInfo[0] && data.userAppInfo[0].deptUserRole)
                  _data.userAppInfo.push(common.isObject(data.userAppInfo[0], data.userAppInfo[0].deptUserRole[0]));
                if (_data.userAppInfo && _data.userAppInfo.length > 0) delete _data.userAppInfo[0].deptUserRole;
                localStorage.setItem('UserInformation_Beef', JSON.stringify(_data));
                this.getWebMenuTreeByAppId(_data.userAppInfo[0]);
              }
            }
          })
          .catch(err => {
            // common.isMessage(this, err);
          });
      }
      // 种畜禽
      if (item.applicationType == 13) {
        localStorage.setItem('applicationType', item.applicationType);
        localStorage.setItem('itemInfo', JSON.stringify(item));
        localStorage.setItem('applicationId', item.applicationId);
        getSeedUserInfo_LB().then(res => {
          const { code, data, msg } = res.data;
          if (Number(code) === 0) {
            // 多个区域 | 一个区域 多个角色
            if (
              (data.userAppInfo && data.userAppInfo.length > 1) ||
              (data.userAppInfo && data.userAppInfo[0].deptUserRole && data.userAppInfo[0].deptUserRole.length > 1)
            ) {
              this.regionalData_ZXQ = this.initInitializeData(data);
              this.regionalStatus_ZXQ = true;
              localStorage.setItem('multiRoleLocalData', JSON.stringify(this.regionalData_ZXQ));
            } else {
              // 一个区域 单个角色
              localStorage.setItem('multiRoleLocalData', JSON.stringify(data));
              let _data = JSON.parse(localStorage.getItem('multiRoleLocalData'));
              _data.userAppInfo = [];
              if (data.userAppInfo && data.userAppInfo[0] && data.userAppInfo[0].deptUserRole)
                _data.userAppInfo.push(common.isObject(data.userAppInfo[0], data.userAppInfo[0].deptUserRole[0]));
              if (_data.userAppInfo && _data.userAppInfo.length > 0) delete _data.userAppInfo[0].deptUserRole;

              // 更新畜只种类及默认值
              if (_data.userAppInfo && _data.userAppInfo.length > 0 && _data.userAppInfo[0].currentLivestockType) {
                this.mutCurrentLivestock(_data.userAppInfo[0].currentLivestockType[0].livestockType);
                this.mutLivestockListStroe(_data.userAppInfo[0].currentLivestockType);
              }
              localStorage.setItem('UserInformation_LB', JSON.stringify(_data));
              this.getWebMenuTreeByAppId(_data.userAppInfo[0]);
            }
            // localStorage.setItem('UserInformation_LB', JSON.stringify(data));
            // window.open(`${window.location.origin}/#/livestock/largeScreen`, '_blank');
            // this.getWebMenuTreeByAppId(data);
          }
        });
      }
    },
    // 见犊补母 - 切换
    multiRoleTab_JDBM(regional, regionalIndex, item, index) {
      this.regionalRoleData_JDBM = this.initInitializeData(this.regionalRoleData_JDBM);
      regional.hidStatus = true;
      this.item_JDBM.showUserInfo = item.showScreenInfo[0];
      // if (this.regionalRoleData_JDBM[index] && this.regionalRoleData_JDBM[index].deptUserRole) {
      //   this.regionalRoleData_JDBM[index].deptUserRole.forEach(dept => {});
      // }
      localStorage.setItem('itemInfo', JSON.stringify(this.item_JDBM));
      localStorage.setItem('applicationType', this.item_JDBM.applicationType);
      localStorage.setItem('userApplication_JDBM', JSON.stringify(item));
      localStorage.setItem('deptUserRole_JDBM', JSON.stringify(regional));
    },
    // 初始化数据
    initInitializeData(data) {
      let _data = data;
      if (_data.userAppInfo && _data.userAppInfo.length > 0) {
        _data.userAppInfo.forEach(item => {
          if (item.deptUserRole && item.deptUserRole.length > 0) {
            item.deptUserRole.forEach(dept => {
              dept.hidStatus = false;
              dept.moduleStatus = false;
              if (['SEED_FARM_OWNER'].includes(dept.roleCode)) dept.moduleStatus = true;
            });
          }
        });
      }
      return _data;
    },
    // 种畜禽 - 切换
    multiRoleTab(regional, regionalIndex, item, index) {
      this.regionalData_ZXQ = this.initInitializeData(this.regionalData_ZXQ);
      regional.hidStatus = true;
      this.regionalCurrentData = regional;
      let _multiRoleLocalData = JSON.parse(localStorage.getItem('multiRoleLocalData'));
      let multiRoleLocalData = JSON.parse(localStorage.getItem('multiRoleLocalData'));
      multiRoleLocalData.userAppInfo = [];
      multiRoleLocalData.userAppInfo.push(
        common.isObject(_multiRoleLocalData.userAppInfo[index], _multiRoleLocalData.userAppInfo[index].deptUserRole[regionalIndex])
      );
      if (multiRoleLocalData.userAppInfo && multiRoleLocalData.userAppInfo.length > 0)
        delete multiRoleLocalData.userAppInfo[0].deptUserRole;
      this.regionalCurrentData_ZXQ = multiRoleLocalData;
      // console.log('this.regionalCurrentData_ZXQ', this.regionalCurrentData_ZXQ);
    },
    // 种畜禽 - 确定
    regionalSubmit_ZXQ() {
      const applicationType = localStorage.getItem('applicationType');
      const _name = applicationType == 14 ? 'UserInformation_Beef' : 'UserInformation_LB';
      // 更新种类数据
      const c = this.regionalCurrentData_ZXQ;
      if (c && c.userAppInfo && c.userAppInfo[0] && c.userAppInfo[0].currentLivestockType) {
        this.mutCurrentLivestock(c.userAppInfo[0].currentLivestockType[0].livestockType);
        this.mutLivestockListStroe(c.userAppInfo[0].currentLivestockType);
      }
      localStorage.setItem(_name, JSON.stringify(this.regionalCurrentData_ZXQ));
      // 处理牧场主登录PC
      if (this.regionalCurrentData_ZXQ.userAppInfo[0].roleCode == 'AREA_FARMER') {
        // 肉牛牧场code
        this.menuList = [
          {
            applicationId: 20,
            applicationType: '14',
            children: null,
            createTime: '2024-06-28 16:06:39',
            menuIcon: 'el-icon-house',
            menuId: '1247',
            menuName: '首页',
            menuPath: '/breedingcattle/welcomeLogin',
            menuSort: '1',
            menuType: '0'
          }
        ];
        localStorage.setItem('menuList', JSON.stringify(this.menuList));
        window.open(`${window.location.origin}/#` + '/breedingcattle/welcomeLogin', '_blank');
      } else if (this.regionalCurrentData_ZXQ.userAppInfo[0].roleCode == 'FARMER_SIGN') {
      } else {
        this.getWebMenuTreeByAppId(this.regionalCurrentData);
      }
    },
    getWebMenuTreeByAppId(data) {
      getWebMenuTreeByAppId({
        applicationId: localStorage.getItem('applicationId'),
        roleCode: data.roleCode,
        menuSort: 'menuSort',
        menuType: '0'
      }).then(res => {
        localStorage.setItem('menuAuthority', JSON.stringify(res.data.data[0].rolePermissionsList));
        this.menuList = res.data.data[0].menuItems;
        localStorage.setItem('menuList', JSON.stringify(this.menuList));
        if (this.menuList[0].children) {
          window.open(`${window.location.origin}/#` + this.menuList[0].children[0].menuPath, '_blank');
        } else {
          window.open(`${window.location.origin}/#` + this.menuList[0].menuPath, '_blank');
        }
      });
    },
    listenerFunction(e) {
      document.addEventListener('scroll', this.handleScroll, true);
    },
    handleScroll(e) {
      let scrollY = e.target.scrollTop;
      if (scrollY > 0) {
        this.scroll = true;
      } else {
        this.scroll = false;
      }
    },
    getuserO() {
      var _this = this;
      getUserAppInfo({}).then(res => {
        let list = res.data.data;
        _this.powerList = [];
        list.forEach(item => {
          // if (item.applicationNo === 'JDBM20220001') {
          //   localStorage.setItem('JDBM', JSON.stringify(item));
          // }
          if (item.authStatus == 2 && item.applicationNo != 'ZJFW20220001') {
            _this.powerList.push(item);
          }
        });
        if (JSON.parse(localStorage.getItem('userInfo')).userId == '1494158832823728786') {
          var obj = {
            applicationName: '设备申请',
            id: 100,
            applicationType: 100
          };
          _this.powerList.push(obj);
        }
        // 助贷管理
        // var obj = {
        //   applicationName: '助贷管理',
        //   id: 55,
        //   applicationType: 55
        // };
        // _this.powerList.push(obj);

        // console.log(_this.powerList);
      });
    },

    enter() {
      this.showList = !this.showList;
    },
    leave() {
      this.showList = !this.showList;
    },
    logins(type) {
      this.showDialog = true;
    },
    loginBtn() {
      var _this = this;

      if (_this.tabIndex == 0) {
        if (_this.subform.mobile == '') {
          _this.$message({
            type: 'none',
            message: '请输入手机号'
          });
          return;
        }
        if (_this.subform.code == '') {
          _this.$message({
            type: 'none',
            message: '请输入验证码'
          });
          return;
        }
        loginCode(_this.subform, _this.loginToken)
          .then(res => {
            if (res.data.data == null) {
              _this.$message({
                type: 'none',
                message: res.data.msg
              });
            } else {
              localStorage.setItem('token', res.data.data.accessToken);
              localStorage.setItem('userPhone', _this.ruleForm.username);
              localStorage.setItem('userInfo', JSON.stringify(res.data.data));
              _this.subform.mobile = '';
              _this.subform.code = '';
              _this.setCode = '获取验证码';
              _this.loginInfo = res.data.data;
              _this.showDialog = false;
              _this.getuserO();
              _this.getUserBaseInfo();
            }

            // this.algoList = response.data.data.records
          })
          .catch(res => {
            _this.logining = false;
            _this.$message({
              type: 'error',
              message: '账号密码错误，请重新输入'
            });
          });
      } else {
        if (_this.ruleForm.username == '') {
          _this.$message({
            type: 'none',
            message: '请输入手机号'
          });
          return;
        }
        if (_this.ruleForm.password == '') {
          _this.$message({
            type: 'none',
            message: '请输入密码'
          });
          return;
        }
        // 密码加密
        let data = {
          password: _this.ruleForm.password
        };
        const user = encryption({
          data: data,
          key: passwordKey,
          param: ['password']
        });
        let ruleForm = {
          username: _this.ruleForm.username,
          scope: 'server',
          password: user.password
        };
        login(JSON.stringify(ruleForm), _this.loginToken).then(res => {
          if (res.data.data == null) {
            _this.$message({
              type: 'none',
              message: res.data.msg
            });
          } else {
            localStorage.setItem('token', res.data.data.accessToken);
            localStorage.setItem('userPhone', _this.ruleForm.username);
            localStorage.setItem('userInfo', JSON.stringify(res.data.data));
            _this.ruleForm.username = '';
            _this.ruleForm.phoneCode = '';
            _this.setCode = '获取验证码';
            _this.loginInfo = res.data.data;
            _this.showDialog = false;
            _this.getuserO();
            _this.getUserBaseInfo();
          }
        });
      }
    },
    keyDown(e) {
      // if (e.keyCode === 13 || e.keyCode === 100) {
      //   console.log(e)
      //   this.loginBtn()
      // }
    },
    tab(i) {
      this.tabIndex = i;
    },
    changePhone(e) {
      console.log(e);
      this.sendCode.username = e.detail.value;
    },
    regest(type) {
      clearInterval(this.clock);
      this.ruleForm.username = '';
      this.ruleForm.phoneCode = '';
      this.setCodes = '获取验证码';
      this.setCode = '获取验证码';
      this.subform.mobile = '';
      this.subform.code = '';
      this.setCode = '获取验证码';
      this.num = 60; // 重置时间
      if (type == 0) {
        this.type = 1;
      } else {
        this.type = 3;
      }
    },
    getCode() {
      this.sendCode.userAccount = this.subform.mobile;
      // let sendData = {
      //   mobile: this.subform.mobile,

      // }
      if (this.sendCode.username == '') {
        alert('请输入手机号');
      } else {
        sendCodeApi(this.sendCode).then(res => {
          if (res.data.code == '0') {
            alert('短信验证码发送成功');
          } else {
            alert(res.data.msg);
          }
          if (res.data.code == '1') {
            return;
          }

          this.setCode = this.num + '秒后重新获取';
          let _this = this;
          _this.clock = setInterval(function () {
            _this.num--;
            if (_this.num > 0) {
              _this.setCode = _this.num + '秒后重新获取';
            } else {
              clearInterval(_this.clock); // 清除js定时器

              _this.setCode = '获取验证码';
              _this.num = 60; // 重置时间
            }
          }, 1000);
        });
      }
    }
  },
  destroyed() {
    // 销毁事件
    // window.removeEventListener("keydown", this.keyDown, false);
  }
};
</script>

<style lang="scss">
@import '../assets/scss/allocation.scss';
.multiRoleDataMun {
  max-height: 500px;
  overflow-y: auto;
}
.multiRoleDataMain {
  .title {
    font-size: $fontSize16;
    color: $fontColor333;
    border-bottom: 1px dotted $borderColor;
    padding: $spacing10 0;
    font-weight: bold;
    span {
      font-size: $fontSize;
      color: $fontSize999;
      margin-left: $spacing10;
      font-weight: normal;
    }
  }
  .multiRoleDataList {
    padding: $spacing10 0;
    display: flex;
    flex-wrap: wrap;
    section {
      padding: $spacing10 $spacing;
      border: 1px solid $borderColor;
      // border-left: 5px solid $borderColor;
      background: $backColorF5;
      margin: 5px $spacing 5px 0;
      border-radius: $borderRdius;
      color: $fontColor333;
      cursor: pointer;
      &.active {
        background: $mainColor_trans;
        border: 1px solid $mainColor_trans;
        color: $mainColor;
        // border-left: 5px solid $mainColor;
        p {
          span {
            color: $mainColor;
          }
        }
      }
      p {
        span {
          font-size: $fontSize;
          color: $fontSize999;
          margin-left: $spacing10;
        }
      }
    }
  }
}
</style>

<style scoped="scoped">
@charset "utf-8";

*,
::after,
::before {
  box-sizing: inherit;
}

html,
body {
  width: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  background: #fff !important;
}

.container {
  background: #fff !important;
  scrollbar-width: none;
  /* firefox */
  -ms-overflow-style: none;
  /* IE 10+ */
}

li,
ul {
  list-style: none;
  padding: 0;
}

.p10 {
  padding-left: 10px;
}

body.regMaskBox_text::-webkit-scrollbar {
  width: 0;
  display: none;
}

body::-webkit-scrollbar {
  width: 0px;
  display: none;
}

body::-webkit-scrollbar-thumb,
body::-webkit-scrollbar-track {
  background-color: #f5f5f5;
  display: none;
}

body::-webkit-scrollbar-thumb:active,
body::-webkit-scrollbar-thumb:hover {
  background-color: #ccc;
  display: none;
}

body.bodyScroll.regMaskBox_text::-webkit-scrollbar {
  width: 0;
  display: none;
}

body.bodyScroll::-webkit-scrollbar {
  width: 0px;
  display: none;
}

body.bodyScroll::-webkit-scrollbar-thumb,
body.bodyScroll::-webkit-scrollbar-track {
  background-color: #f5f5f5;
  display: none;
}

body.bodyScroll::-webkit-scrollbar-thumb:active,
body.bodyScroll::-webkit-scrollbar-thumb:hover {
  background-color: #ccc;
  display: none;
}

#wrap {
  width: 100%;
  height: 100%;
  -webkit-transition: all 300ms;
}

a {
  text-decoration: none;
}

/**nav**/
.nav {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;

  /* width: 100%; */
  height: 80px;
  z-index: 99;
  transition: all 300ms;
  /*background: linear-gradient(to right, #00404c, #003b27) !important;*/
}

.navbars.center {
  width: 1200px;
  margin: auto;
  position: absolute;
  right: 0;
  margin: auto;
  left: 0;
  height: 80px !important;
}

.logos {
  float: left;
}

.logos a {
  height: 80px;
  display: block;
  line-height: 80px;
}

.logos a img {
  /* line-height:80px; */
  /* vertical-align:middle; */
  margin-top: 20px;
  width: 140px;
  height: 40px;
}

.navbar-menu {
  line-height: 80px;
  height: 100%;
  float: left;
  margin-left: 80px;
}

.navbar-menu ul,
.navbar-login ul {
  text-align: left;
  margin: 0;
  padding: 0;
}

.navbar-menu ul li,
.navbar-login ul li {
  display: inline-block;
  line-height: 80px;
  margin-right: 40px;
  color: #fff;
  cursor: pointer;
}

.navbar-menu ul li a,
.navbar-login ul li a {
  font-size: 18px !important;
  font-weight: 600;
  color: #fff;
}

.navbar-login {
  line-height: 80px;
  height: 100%;
  float: right;
  margin-right: 5px;
}

.navbar-loginBtn {
  margin-right: 0 !important;
  position: relative;
}

.navbar-loginBtn::after {
  content: '';
  position: absolute;
  width: 100%;
  height: 40px;
  left: -5px;
  top: 0;
  bottom: 0;
  padding: 0 5px;
  margin: auto;
  background: rgba(0, 0, 0, 0.25);
  border-radius: 20px;
  z-index: -1;
}

.navbar-loginBtn span {
  display: inline-block;
  padding: 0 10px;
  font-size: 18px;
}

.nav.navFixed {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 80px;
  z-index: 9999;
  background: linear-gradient(to right, #00404c, #003b27);
}

.nav.navFixed .logos a,
.nav.navFixed .navbar-menu,
.nav.navFixed .navbar-login,
.nav.navFixed .navbar-menu ul li,
.nav.navFixed .navbar-login ul li {
  line-height: 80px;
}

/**banner切换**/
.banner {
  width: 100%;
  height: 640px;
  background: url(../assets/img/u842.png) no-repeat center;
  background-size: cover;
  position: relative;
  -webkit-transition: all 300ms;
}

.banner .center {
  width: 1200px;
  margin: 0 auto;
}

.header-inner {
  padding-top: 235px;
  padding-bottom: 235px;
}

.header-inner img {
  float: left;
}

.header-innerTxt {
  display: inline-block;
  height: 210px;
  /* margin-top: 25px; */
  float: left;
  margin-left: 10px;
}

.header-innerTxt h1 {
  margin-top: 10px;
  font-size: 60px;
  line-height: 90px;
  color: #fff;
  font-weight: 700;
  display: inline-block;
  margin-bottom: 10px;
}

.header-innerTxt p {
  font-size: 30px;
  color: rgba(255, 255, 255);
  margin-bottom: 0;
  height: 30px;
  line-height: 30px;
}

/**系统公告**/
.system-notice .center {
  height: 99px;
  overflow: hidden;
  border-bottom: solid 1px #e5e5e5;
}

.sysNotL {
  float: left;
  line-height: 99px;
  font-size: 20px;
  color: #999;
}

.sysNotL img {
  margin-left: 20px;
  height: 20px;
  opacity: 0.25;
}

.sysNotC {
  float: left;
  margin-left: 35px;
  height: 40px;
  overflow: hidden;
  margin-top: 30px;
}

.sysNotC ul li {
  height: 40px;
  line-height: 40px;
}

.sysNotC ul li a {
  font-size: 20px;
  color: #333;
}

.sysNotC ul li a .new {
  width: 40px;
  height: 20px;
  background-color: rgba(255, 120, 117, 1);
  border: none;
  border-radius: 2px;
  font-size: 14px;
  color: #ffffff;
  line-height: 20px;
  margin-left: 15px;
  display: inline-block;
  text-align: center;
}

.sysNotR {
  float: right;
  line-height: 99px;
}

.sysNotR a {
  font-size: 18px;
  color: #999;
}

.sysNotR a:hover {
  color: #666;
}

a.link {
  width: 118px;
  height: 38px;
  float: right;
  text-align: center;
  line-height: 38px;
  font-size: 16px;
  background-color: rgba(60, 170, 247, 1);
  border-radius: 20px;
  color: #fff;
  border: solid 1px rgba(60, 170, 247, 1);
}

a.link:hover {
  color: rgba(60, 170, 247, 1);
  background: none;
}

/**产品功能**/
.collegeCont {
  width: 1200px;
  margin: 0 auto;
  background: #fff;
  margin-top: 80px;
}

.collegeCont h1 {
  height: 40px;
  position: relative;
  text-align: center;
  font-family: '苹方 特粗', '苹方 中等', '苹方';
  margin: auto;
  font-weight: 900;
  font-size: 36px;
  color: #333;
  line-height: 40px;
}

.collegeContTxt p {
  width: 80%;
  margin: 45px auto 0;
  font-size: 16px;
  color: #999;
  line-height: 30px;
  text-indent: 32px;
}

.collUls {
  display: inline-block;
  margin: 50px auto 0;
}

.collUls li {
  float: left;
  width: 300px;
  height: 300px;
  text-align: center;
  -webkit-transition: all 200ms;
}

.collUls li a {
  display: block;
  width: 300px;
  height: 300px;
}

.collUls li a img {
  width: 80px;
  height: 80px;
  padding: 60px 0 30px 0;
}

.collUls li a .collLis_tit {
  height: 20px;
  margin-bottom: 25px;
}

.collUls li a .collLis_tit h6 {
  height: 20px;
  font-size: 20px;
  line-height: 20px;
  font-family: '苹方 特粗', '苹方 中等', '苹方';
  color: #333;
  font-weight: 900;
  text-align: center;
  margin: 0;
}

.collUls li a .collLis_txt p {
  height: 15px;
  line-height: 15px;
  font-weight: 400;
  font-size: 16px;
  font-family: '苹方 中等', '苹方';
  color: #999999;
  text-align: center;
  margin-bottom: 10px;
}

.collUls li a .collLis_txt p span:hover {
  color: #666;
}

.collUls li a .collLis_txt p span {
  border-right: solid 1px rgba(155, 126, 180, 0.5);
  padding: 0 10px;
  display: inline-block;
  height: 15px;
  line-height: 15px;
}

.collUls li a .collLis_txt p span:nth-child(2n) {
  border: none;
}

.collUls li:hover,
.collUls li.cur {
  -moz-box-shadow: 0px 10px 25px rgba(0, 0, 0, 0.000009);
  -webkit-box-shadow: 0px 10px 25px rgba(0, 0, 0, 0.00008);
  box-shadow: 0px 10px 25px rgba(0, 0, 0, 0.0009);
}

/**应用案例**/
.case {
  height: 720px;
  margin-top: 70px;
}

.scrollleft {
  height: 720px;
  position: relative;
}

.scrollleft h3 {
  font-weight: 700;
  font-size: 54px;
  color: #ffffff;
  text-align: center;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  z-index: 96;
  height: 60px;
  line-height: 60px;
}

.scrollleft {
  width: 100%;
}

/* .scrollleft ul {
    position: relative;
    width: 100%;
    height: 780px;
    overflow: hidden;
  }

  .scrollleft ul:after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    z-index: 9;
    background: rgba(0, 0, 0, .5);
  }

  .scrollleft ul li {
    width: 100%;
    height: 800px;
    float: left;
    display: inline;
    background: url(../assets/img/caseimg4.jpg) repeat-x top center;
    background-size: 120% 720px;
  }

  .scrollleft ul li img {
    width: 100%;
    height: 720px;
  } */

/**生态合作伙伴**/
.blogroll {
  width: 1200px;
  margin: 0 auto;
  margin-top: 80px;
  margin-bottom: 0;
}

.blogroll .center {
  text-align: center;
}

.blogroll .center h3 {
  font-weight: 700;
  font-size: 36px;
  text-align: center;
  line-height: 40px;
}

.blogroll ul {
  padding: 40px 0;
  display: inline-block;
  margin: auto;
}

.blogroll ul li {
  float: left;
  margin-right: 40px;
  margin-bottom: 40px;
}

.blogroll ul li a {
  display: block;
  width: 160px;
  height: 80px;
}

.blogroll ul li a img {
  width: 160px;
  height: 80px;
  -webkit-transition: opacity 300ms;
}

.blogroll ul li a img:hover {
  opacity: 0.7;
}

/**联系我们**/
.contact {
  width: 1200px;
  height: 160px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0px 10px 25px rgba(0, 0, 0, 0.0980392156862745);
}

.contact ul li {
  width: 400px;
  float: left;
  position: relative;
}

.contact ul li:after {
  content: '';
  position: absolute;
  right: 0;
  top: 30px;
  margin: auto;
  width: 1px;
  height: 100px;
  background: url(../assets/img/u155.svg) no-repeat center;
  background-size: cover;
  z-index: 9999;
}

.contact ul li:last-child:after {
  display: none;
}

.contact ul li a {
  display: block;
  padding: 0 40px;
}

.contact ul li a div.cotL {
  float: left;
}

.contact ul li a div.cotL img {
  width: 40px;
  height: 40px;
  margin-right: 40px;
  margin-top: 40px;
}

.contact ul li a div.cotL p {
  font-size: 16px;
  color: #999;
  margin: 10px 0 0 5px;
}

.contact ul li a div.cotR {
  float: left;
  margin-top: 30px;
}

.contact ul li a div.cotR p {
  width: 240px;
  height: 20px;
  font-family: '苹方 中等', '苹方';
  font-weight: 400;
  font-size: 20px;
  line-height: 20px;
}

.contact ul li:last-child a div.cotR p {
  line-height: 30px;
}

.power {
  font-size: 20px;
  color: #999;
  text-align: center;
  margin: 80px auto 60px;
}

.power a {
  margin-left: 20px;
  color: #999;
}

.foot {
  height: 496px;
  width: 100%;
  background: url(../assets/img/u968.png) no-repeat center;
  background-size: cover;
}

.foot .center {
  position: relative;
}

.foot .center img {
  position: absolute;
}

.foot .center img:nth-child(1) {
  left: 480px;
  top: 150px;
}

.foot .center img:nth-child(2) {
  right: 150px;
  top: 200px;
}
.foot-list {
  width: 240px;
  height: 40px;
  position: absolute;
  top: 380px;
  left: 480px;
}
.foot-list p {
  width: 74px;
  height: 40px;
  display: inline-block;
  font-weight: 400;
  font-size: 16px;
  line-height: 40px;
  margin-block-start: 0;
  margin-block-end: 0;
  background: #ffffff;
  border-radius: 60px;
  position: relative;
  padding-left: 36px;
}
.foot-list i {
  position: absolute;
  width: 20px;
  height: 20px;
  display: inline-block;
  left: 12px;
  top: 8px;
}
.foot-list-and {
  background: url(../assets/icon/ios.png);
}
.foot-list-ios {
  background: url(../assets/icon/android.png);
}

/**登录注册**/
.mask {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
}

.loginBox {
  position: relative;
  width: 640px;
  height: 400px;
  left: 0;
  right: 0;
  top: 20px;
  bottom: 0;
  margin: auto;
  background: #fff;
  z-index: 999;
  border-radius: 10px;
  padding: 40px;
}

.loginBoxL {
  float: left;
  width: 280px;
  position: relative;
  padding-right: 40px;
}

.loginBoxL::after {
  content: '';
  position: absolute;
  width: 1px;
  height: 400px;
  background: #d9d9d9;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
}

.loginTop ul li {
  font-size: 18px;
  color: #666;
  height: 40px;
  display: inline-block;
  width: 49%;
  text-align: center;
  position: relative;
  cursor: pointer;
}

.loginTop ul li.cur {
  font-weight: 700;
  color: #30bf30;
}

.loginTop ul li.cur::after {
  content: '';
  position: absolute;
  width: 120px;
  height: 4px;
  background: rgba(48, 191, 48, 1);
  right: 0;
  left: 0;
  bottom: 0;
  margin: auto;
}

.loginBot ul li {
  height: 69px;
  line-height: 69px;
  border-bottom: solid 1px #d9d9d9;
  font-size: 16px;
  color: #333;
}

.loginBot ul li input {
  border: none;
  height: 50px;
}

.loginBot ul li button {
  background: none;
  color: #30bf30;
  border: none;
  padding: 0;
  margin: 0;
  float: right;
  outline: none;
}

.loginBot ul li button:focus {
  outline: none;
}

.loginBot ul li span {
  margin-top: 20px;
  display: inline-block;
  float: right;
  width: 30px;
  height: 30px;
  background: url(../assets/img/u909.png) no-repeat center;
  background-size: 20px;
  opacity: 0.6;
  cursor: pointer;
}

.loginBot ul li span.open {
  background: url(../assets/img/open.png) no-repeat center;
  background-size: 28px;
}

.loginBot ul li a {
  font-size: 14px;
  color: #999;
  text-decoration: underline;
}

.loginBot ul li a:hover {
  text-decoration: underline !important;
}

.loginBot ul li a:last-child {
  float: right;
}

.loginBot ul li:last-child {
  border: none;
}

.loginBot ul li p {
  font-size: 14px;
  color: #999;
}

.loginBtnBox .loginBtn {
  width: 280px;
  height: 50px;
  display: block;
  background: -webkit-linear-gradient(180deg, rgba(48, 191, 48, 1) 0%, rgba(149, 229, 69, 1) 100%);
  background: -moz-linear-gradient(270deg, rgba(48, 191, 48, 1) 0%, rgba(149, 229, 69, 1) 100%);
  background: linear-gradient(270deg, rgba(48, 191, 48, 1) 0%, rgba(149, 229, 69, 1) 100%);
  border-radius: 25px;
  font-size: 20px;
  color: rgba(255, 255, 255, 0.996078431372549);
  text-align: center;
  line-height: 50px;
  margin: 20px auto;
}

.loginBtnBox .loginTxt {
  font-size: 14px;
  color: #999;
  text-align: center;
}

.loginBtnBox .loginTxt a {
  color: #30bf30;
}

.loginBoxR {
  width: 320px;
  float: right;
  text-align: center;
}

.loginBoxR h3 {
  color: #666;
  font-size: 18px;
  line-height: 30px;
  text-align: center;
}

.loginBoxR h3 a {
  color: #30bf30;
  padding-left: 10px;
}

.loginBoxR img {
  width: 160px;
  height: 160px;
  border: solid 1px #d9d9d9;
  display: block;
  padding: 5px;
  margin: 70px auto 55px;
}

.loginBoxR p {
  text-align: center;
  font-size: 14px;
  color: #999;
}

.contactUs .center {
  width: 1200px;
  margin: 0 auto;
}

/***********中屏幕*********/
@media (max-width: 1159px) {
}

/***********小屏幕*********/
@media (max-width: 959px) {
  .banner {
    height: 296px;
    background: none;
  }

  .header {
    top: 20px;
    height: auto;
  }

  .center {
    width: calc(100% - 50px);
  }

  .contact ul {
    margin-bottom: 20px;
  }

  .contts.cont ul li {
    border: none;
    padding: 0;
  }

  .contUls li:hover {
    background: none;
    transform: translate(0, 0px);
  }

  .contUls {
    text-align: center;
  }

  .contUls li {
    width: 32%;
    height: auto;
    border-radius: 5px;
    margin: 15px 0;
    float: none;
    display: inline-block;
  }

  .contUls li:nth-child(3n) {
    margin: 15px 0;
  }

  .contUls li a img {
    width: 30px;
    height: auto;
    margin: 0px 0 10px 0;
  }

  .contUls li a p {
    font-size: 15px;
  }

  .cont .center:after {
    background-size: 360px auto;
  }

  .contact {
    width: calc(100% - 20px);
    left: 10px;
    right: 10px;
    height: auto;
    margin: auto;
    bottom: -120px;
  }

  .contact ul {
    margin-bottom: 0px;
  }

  .contact > ul > li {
    float: none;
    height: 20px;
    line-height: 20px;
    margin-top: 30px;
    border-bottom: solid 1px rgba(0, 0, 0, 0.1) !important;
    width: calc(100% - 40px);
    margin: 20px auto 0;
    padding-bottom: 20px !important;
  }

  .contact > ul > li:last-child {
    border: none !important;
  }

  .contact ul li a {
    height: 20px;
    line-height: 20px;
    padding: 0;
  }

  .contact ul li a img {
    width: 20px;
    height: 20px;
    margin-right: 10px;
  }

  .contact ul li a p {
    width: auto;
    font-size: 14px;
    height: 20px;
    line-height: 20px;
  }

  .contact ul li:after {
    display: none;
  }

  .contact ul li:last-child a p {
    margin: 0;
    height: 20px;
    line-height: 20px;
  }

  .collUls {
    margin: 0px auto 40px;
    text-align: center;
  }

  .collUls li {
    width: 150px;
    height: 150px;
    float: none;
    display: inline-block;
    position: relative;
  }

  .collUls li:hover,
  .collUls li.cur {
    -moz-box-shadow: none;
    -webkit-box-shadow: none;
    box-shadow: none;
  }

  .collUls li:nth-child(2n):before {
    display: none;
  }

  .collUls li:hover:before {
    display: none;
  }

  .collUls li:hover:nth-child(2n):before {
    display: none;
  }

  .collUls li.afterNone:before {
    display: none;
  }

  .collUls li:nth-child(8):after {
    display: none;
  }

  .collUls li a {
    width: 150px;
    height: 150px;
  }

  .collUls li a img {
    width: 60px;
    height: auto;
    padding: 30px 0 20px 0;
  }

  .collUls li a .collLis_tit h6 {
    font-size: 15px;
  }

  .collUls li a .collLis_txt p {
    display: none;
  }
}

/* .scrollleft div {
    width: 100%;
    height: 420px;
    float: left;
    display: inline;
    background: url(../assets/img/caseimg4.jpg) repeat-x top center;
    background-size: 120% 420px;
    position: relative;
  }
*/

.scrollleft div::after {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  z-index: 9;
  background: rgba(0, 0, 0, 0.3);
}

.el-dialog {
  width: 740px !important;
  border-radius: 20px;
}

.loginBotTab input {
  font-size: 18px;
}

.user > img:nth-child(2) {
  width: 15px !important;
  height: 15px !important;
}

.user > img {
  width: 25px;
  height: 25px;
  margin: 0 5px;
  display: inline-block;
}

.user > img:nth-child(3) {
  border-radius: 100px !important;
  margin-top: -3px;
  vertical-align: middle;
}

.menuCover {
  position: absolute;
  top: 80px;
  right: 0;
  width: 180px;
  background: #fff;
  padding: 10px 15px;
  border-radius: 16px;
  color: #999;
  font-size: 18px;
  line-height: 40px;
}

.powerCover {
  /* margin-left: 24px; */
  color: #000;
  font-weight: 500;
  text-align: center;
}

.powerCover > div:hover {
  color: #30bf30 !important;
}

.backWhite {
  background: linear-gradient(to right, #00404c, #003b27) !important;
}

/* /deep/ .el-dialog {
  height: 540px !important;
  border-radius: 10px !important;
  padding: 0 !important;
}

/deep/ .el-dialog__body {
  padding: 0px 20px !important;
} */

input {
  border: none !important;
}

.scrollleft {
  position: relative;
}

.bgCase {
  min-width: 100%;
  height: 720px;
  overflow: hidden;
  /* overflow-x:scroll; */
}

.bgCase .bg1 {
  background: url('../assets/img/caseimg4.jpg');
  height: 720px;
  width: 150%;
  background-size: cover;
  animation: bg1-data-v-c2c41fa4 40s linear infinite;
}

.bgCase > div {
  float: left;
}

.bgCase .bg2 {
  background: url('../assets/img/caseimg4.jpg');
  width: 150%;
  height: 480px;
  background-size: cover;
  animation: bg2-data-v-c2c41fa4 150s linear infinite;
  opacity: 0.5;
}

@keyframes bg1-data-v-c2c41fa4 {
  0% {
    margin-left: 0;
  }

  to {
    margin-left: -50%;
  }
}

@keyframes bg2-data-v-c2c41fa4 {
  0% {
    margin-left: 0;
  }

  to {
    margin-left: -100%;
  }
}

input {
  outline-color: white !important;
}

.container {
  height: 100vh;
  overflow-y: scroll;
}

.container::-webkit-scrollbar {
  display: none;
  /* Chrome Safari */
}
</style>



// WEBPACK FOOTER //
// src/views/home.vue